import { format } from 'date-fns';

import checkAccess from 'utils/roles/checkAccess';
import getFranchiseRegion from 'utils/jwt/getFranchiseRegion';
import path from 'utils/path';

export const routerPath = {
  root: '/registered-Users',
  link: '/general/registered-Users',
  go_userActivity: ({ id, name, surname }) => path(id, `/activity/?name=${name}&surname=${surname}`),
};

export const getColumns = ({
  addCompStatus,
  addWorkoutPlansStatus,
  addCoins,
  addCorpId,
  addCredits,
  blockChallenges,
  assignInduction,
  goUserActivity,
}) => [
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'surname', label: 'Surname', align: 'center' },
  {
    id: 'createdAt',
    label: 'Date',
    customValue: (val) => format(new Date(val.createdAt), 'dd/MMM/yyyy p'),
    align: 'center',
    nameForSort: 'created_at',
    sx: {
      minWidth: 200,
    },
  },
  { id: 'email', label: 'Email', align: 'center' },
  { id: 'phoneNumber', label: 'Cell number', align: 'center', nameForSort: 'phone_number' },
  { id: 'corporationName', label: 'Corporation Name', align: 'center', nameForSort: 'corporation_name' },
  {
    id: 'complimentaryAccess',
    label: 'Complimentary Access',
    customValue: (val) => (val.complimentaryAccess ? 'Active' : 'Inactive'),
    align: 'center',
    nameForSort: 'complimentary_access',
  },
  {
    id: 'accessWorkoutPlans',
    label: 'Workout Plans',
    customValue: (val) => (val.accessWorkoutPlans ? 'Active' : 'Inactive'),
    align: 'center',
    nameForSort: 'access_workout_plans',
  },
  {
    id: 'platform',
    label: 'Platform',
    align: 'center',
    customValue: (val) => {
      if (val.platform === 'android') {
        return 'Android';
      }

      return val.platform;
    },
    nameForSort: 'platform_type',
  },
  { id: 'region', label: 'Region', align: 'center' },
  {
    id: 'more-menu',
    type: 'menu',
    items: [
      { id: 1, name: 'Complimentary', action: addCompStatus, icon: 'tabler:free-rights' },
      { id: 1, name: 'Workout Plans', action: addWorkoutPlansStatus, icon: 'mdi:dumbbell' },
      { id: 2, name: 'Add Coins', action: addCoins, icon: 'ph:coins' },
      { id: 3, name: 'Add Credits', action: addCredits, icon: 'ic:outline-credit-card' },
      { id: 4, name: 'Add Corporation', action: addCorpId, icon: 'ic:baseline-corporate-fare' },
      { id: 5, name: 'Blocked Challenges', action: blockChallenges, icon: 'game-icons:sport-medal' },
      { id: 6, name: 'Assign Induction', action: assignInduction, icon: 'icon-park-outline:sport' },
      { id: 7, name: 'User Activity', action: goUserActivity, icon: 'mdi:text-box-multiple-outline' },
    ],
    disableSort: true,
  },
];

export const getFilters = ({ searchBy, region, corporateId, dateRange, platform, complimentaryAccess, options }) => [
  {
    id: 'name',
    type: 'search',
    placeholder: 'Search by name, surname, phone, email',
    action: searchBy.change,
  },
  {
    id: 'dateRange',
    variant: 'date',
    type: 'dateRange',
    value: dateRange.value,
    action: dateRange.change,
  },
  {
    id: 'platform',
    type: 'select',
    label: 'Platform',
    value: platform.value,
    action: platform.change,
    items: [
      { id: 'all', name: 'All' },
      { id: 'N/A', name: 'N/A' },
      { id: 'iOS', name: 'iOS' },
      { id: 'android', name: 'Android' },
    ],
  },
  {
    id: 'corporateId',
    type: 'autocomplete',
    label: 'Corporate',
    value: corporateId.value,
    action: corporateId.change,
    items: options?.corporations ? ['All', ...options.corporations] : ['All'],
  },
  {
    id: 'region',
    type: 'select',
    label: 'Region',
    value: checkAccess([2]) ? getFranchiseRegion() : region.value,
    action: region.change,
    items: options?.regions?.length ? ['all', ...options.regions] : ['all'],
    disabledEdit: checkAccess([2]),
  },
  {
    id: 'complimentaryAccess',
    type: 'switch',
    label: 'Complimentary Access',
    value: complimentaryAccess.value === 'true',
    action: complimentaryAccess.change,
  },
];
